<template>
  <div class="pc-components-flow">
    <div
      class="pc-components-flow-title"
      :class="isOpen ? 'pc-components-flow-open' : ''"
    >
      <div>{{ data.name }}</div>
      <div @click="open">
        <i :class="isOpen ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
      </div>
    </div>
    <div class="pc-components-flow-content" v-if="isOpen">
      <template v-for="(item, index) in data.data">
        <flow-node :data="item" :info="data" :key="index" :styles="index == 0 ? 'margin-top: 10px;':''"></flow-node>
      </template>
    </div>
  </div>
</template>

<script>
import flowNode from './flowNode.vue'

export default {
  props: ['data'],
  components: { flowNode },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    open() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style lang="scss">
.pc-components-flow {
  background-color: #fff;
  margin-top: 10px;
  border-radius: 6px;
  .pc-components-flow-title {
    padding: 0 20px;
    font-size: 12px;
    font-weight: bold;
    color: #333333;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
  }
  .pc-components-flow-open {
    border: 1px solid #f2f2f2;
  }
  .pc-components-flow-content {
    overflow: auto;
    height: 500px;
    padding-right: 20px;
    .pc-components-flow-item {
      display: flex;
      justify-content: space-between;
      align-content: center;
      height: 90px;
      .left {
        display: flex;
        position: relative;
        width: 56px;
        align-items: center;
        justify-content: center;
        .left-line {
          position: absolute;
          z-index: 0;
          left: 28px;
          top: 0px;
          width: 1px;
          height: 100%;
          background: #000000;
          opacity: 0.05;
        }
        .left-node {
          z-index: 1;
        }
      }
      .right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        height: 80px;
        background: #fbfbfb;
        border: 1px solid #f3f3f3;
        border-radius: 4px;
        position: relative;
        .right-icon {
          margin-left: 20px;
          margin-top: 20px;
        }
        .right-labels {
          flex: 1;
          margin-left: 17px;
          padding: 20px 0;
        }
        .right-btn {
          position: absolute;
          top: 47px;
          right: 23px;
        }
      }
    }
  }
}
</style>